module.exports = __webpack_public_path__ + "static/tesla-home-5e8a671eca84ac9ed0e46687e8104bfb.svg";